import {priceNumber} from './price-movement';

export function validateTradeEntry(trade, {mode, reward, rewardUnit} = {}) {
  if (trade.mainChart?.reading || (trade.images || []).some(image => image?.reading)) return 'Wait for the chart to finish loading before saving.';
  if (!String(trade.instrument || '').trim()) return 'Choose an instrument before saving.';
  if (!['LONG','SHORT'].includes(trade.direction)) return 'Choose Long or Short before saving.';
  if (!['WIN','LOSS','BE','OPEN'].includes(trade.result)) return 'Choose a trade result before saving.';
  const date = new Date(`${trade.date}T00:00:00Z`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(trade.date || '') || !Number.isFinite(date.getTime()) || date.toISOString().slice(0,10) !== trade.date) return 'Choose a valid trade date.';
  for (const [key, label] of [['entry','Entry price'],['sl','Stop loss'],['tp','Take profit'],['closePrice','Exit price'],['riskPct','Risk'],['returnPct','Return']]) {
    if (trade[key] != null && String(trade[key]).trim() !== '' && priceNumber(trade[key]) == null) return `${label} must be a valid number.`;
  }
  if (priceNumber(trade.riskPct) < 0) return 'Enter risk as a positive percentage, or leave it blank if unknown.';
  if (mode === 'quick' && trade.result !== 'BE' && String(reward || '').trim()) {
    if (priceNumber(reward) == null) return 'Enter a valid reward or loss size.';
    if (rewardUnit === 'R' && !(priceNumber(trade.riskPct) > 0)) return 'Enter your risk % to convert R into a return, or switch the reward unit to %.';
  }
  return '';
}
